export const addDofollowToAnchors = (html = "") => {
  if (!html || typeof html !== "string") return "";

  // String-based so it behaves identically on server and client (no DOMParser).
  return html.replace(/<a\b([^>]*)>/gi, (match, attrs) => {
    const hrefMatch = attrs.match(
      /\shref\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i,
    );
    const href = hrefMatch
      ? (hrefMatch[1] ?? hrefMatch[2] ?? hrefMatch[3] ?? "")
      : "";

    // Only touch absolute external links, same as before
    if (!href.startsWith("http")) return match;

    // Strip any existing rel/target, then add rel="dofollow"
    const cleaned = attrs.replace(
      /\s(?:rel|target)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi,
      "",
    );

    return `<a${cleaned} rel="dofollow">`;
  });
};
